
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const initialize = (root) => {
    if (!motion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) if (entry.isIntersecting) { entry.target.classList.remove('bv-soul-enter'); observer.unobserve(entry.target); }
      }, {threshold: 0.08});
      root.querySelectorAll('[data-bv-reveal]').forEach((node) => { node.classList.add('bv-soul-enter'); observer.observe(node); });
    }
    root.querySelectorAll('[data-bv-tilt]').forEach((frame) => {
      if (frame.dataset.bound) return;
      frame.dataset.bound = 'true';
      let tick;
      frame.addEventListener('pointermove', (event) => {
        if (motion.matches || !finePointer.matches) return;
        const box = frame.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width - 0.5) * 3;
        const y = ((event.clientY - box.top) / box.height - 0.5) * -3;
        cancelAnimationFrame(tick);
        tick = requestAnimationFrame(() => { frame.style.setProperty('--bv-rotate-x', `${y}deg`); frame.style.setProperty('--bv-rotate-y', `${x}deg`); });
      });
      const reset = () => { cancelAnimationFrame(tick); frame.style.removeProperty('--bv-rotate-x'); frame.style.removeProperty('--bv-rotate-y'); };
      frame.addEventListener('pointerleave', reset);
      motion.addEventListener('change', reset);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true}); else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  motion.addEventListener('change', () => { if (motion.matches) document.querySelectorAll('.bv-soul-enter').forEach(node => node.classList.remove('bv-soul-enter')); });
})();


document.addEventListener('click', (event) => {
  const button = event.target.closest('media-gallery [data-target] button, media-gallery [data-target] a');
  if (!button) return;
  const thumbnail = button.closest('[data-target]');
  const gallery = button.closest('media-gallery');
  const target = gallery.querySelector(`[data-media-id="${thumbnail.dataset.target}"]`);
  if (!target || target.classList.contains('is-active')) return;
  if (typeof gallery.setActiveMedia === 'function') {
    gallery.setActiveMedia(thumbnail.dataset.target, false);
    return;
  }
  gallery.querySelectorAll('[data-media-id]').forEach(media => media.classList.toggle('is-active', media === target));
  gallery.querySelectorAll('[data-target] button, [data-target] a').forEach(control => control.removeAttribute('aria-current'));
  button.setAttribute('aria-current', 'true');
  target.parentElement.scrollTo({left:target.offsetLeft,behavior:'instant'});
  const liveRegion = gallery.querySelector('[id^="GalleryStatus"]');
  if (liveRegion) {
    liveRegion.setAttribute('aria-hidden', 'false');
    liveRegion.textContent = button.getAttribute('aria-label');
  }
});
